import { render, staticRenderFns } from "./FormularioSeleccionOrigen.vue?vue&type=template&id=0931b182&scoped=true"
import script from "./FormularioSeleccionOrigen.vue?vue&type=script&lang=js"
export * from "./FormularioSeleccionOrigen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0931b182",
  null
  
)

export default component.exports